export default __webpack_public_path__ + "static/media/startFramingImg.efddd06c.png";